import logoText from '../../../assets/images/logos/logo_text.png';
import TradeNowButton from './TradeNowButton/TradeNowButton';
import styles from './BackgroundImages.module.css';
import { FlexContainer } from '../../../styled/Common';
import { HeroContainer } from '../../../styled/Components/Home';
import { BiFontSize } from 'react-icons/bi';

export default function Hero() {
    return (
        <HeroContainer
            justifyContent='center'
            alignItems='center'
            rounded
            fullHeight
            fullWidth
            id='hero'
            className={styles.home_wallpaper}
        >
            <FlexContainer
                flexDirection='column'
                alignItems='center'
                justifyContent='center'
                gap={32}
            >
                <h1 style={{fontWeight:'bold',fontSize:'150px',color:'lightyellow'}}>MetaXDex</h1>

                <TradeNowButton fieldId='trade_now_btn_in_hero' />
            </FlexContainer>
        </HeroContainer>
    );
}
